<template>
	<div class="createInventoryTemplateComponent">
		<button ref="btnSetComponentLocal" @click="setComponentLocal" v-show="false">Setear Component Local</button>
		<div v-show="wizard == 1">
			<h5 class="mb-1">Busquemos los modulos para tomar los articulos</h5>
			<stores-component
				ref="storesComponent"
				:multipleSelection="true"
				@actionGetStoreRackSideRowColumnIdsSelected="actionGetStoreRackSideRowColumnIdsSelectedLocal">
			</stores-component>
		</div>
		<div v-show="wizard == 2">
			<h5 class="mb-1">Seleccionemos los articulos</h5>
			<table class="table table-sm">
				<thead>
					<tr>
						<th>ID</th>					
						<th>Producto</th>					
						<th>Ubicación</th>					
						<th class="text-center">Cantidad</th>					
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, index) in listInventoryTemplateDetailFilter" :key="index">
						<td>{{ item.product_id }}</td>
						<td>{{ item.product.name }}</td>
						<td>{{ item.store_rack_side_row_column.store.name + ' ' + item.store_rack_side_row_column.store_rack.name + ' ' + item.store_rack_side_row_column.store_rack_side.name + ' ' + item.store_rack_side_row_column.name + '' + item.store_rack_side_row_column.store_rack_side_row.name}}</td>
						<td class="text-center">{{ methodFormatNumber(item.quantity) }}</td>
					</tr>
				</tbody>
			</table>
			<div>
				<input type="checkbox" v-model="quantityCero"/> <small><i>Visualizar productos en 0</i></small>
			</div>
		</div>
		<div v-show="wizard == 3">
			<h5 class="mb-1">Demosle un nombre a la planilla</h5>
			<input v-model="objectInventoryTemplate.name" placeholder="Ingrese el nombre de la planilla" class="form-control form-control-sm">
		</div>
		<hr>
		<div class="text-">
			<button @click="wizard--" :disabled="wizard == 1">Atras</button>
			<button @click="saveInventoryTemplateLocal" class="btn btn-primary btn-sm float-right" v-if="maxwizard == wizard" :disabled="objectInventoryTemplate.name.trim().length < 3">Crear Planilla</button>
			<button @click="actionBtnNext" class="btn btn-primary btn-sm float-right" v-else>Siguiente</button>
		</div>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import errors from '@/mixins/errors.js'
	import axiosAction from '@/mixins/axiosAction.js'
	import productStoreRackSideRowColumn from '@/mixins/products/productStoreRackSideRowColumn.js'
	import inventoryTemplate from '@/mixins/inventories/inventoryTemplate.js'
	import inventoryTemplateDetail from '@/mixins/inventories/inventoryTemplateDetail.js'

	import StoresComponent from '@/components/StoresComponent.vue'

	export default {
		name: 'CreateInventoryTemplateComponent',
		mixins: [axiosAction, errors, mixin, productStoreRackSideRowColumn, inventoryTemplate, inventoryTemplateDetail],
		props: ['inventoryId'],
		data() {
			return {
				wizard: 1,
				maxwizard: 3,
				quantityCero: false,
				storeRackSideRowColumnIds: []
			}
		},
		components: {
			'stores-component': StoresComponent,
		},
		computed: {
			listInventoryTemplateDetailFilter() {
				let list = []
				list = this.listInventoryTemplateDetail.filter((e) => {
					if(!this.quantityCero) {
						if(e.quantity == 0) {
							return false
						}
					}
					return true
				})
				return list
			}
		},
		methods: {
			actionGetStoreRackSideRowColumnIdsSelectedLocal(storeRackSideRowColumnIds) {
				this.storeRackSideRowColumnIds = []
				this.storeRackSideRowColumnIds = storeRackSideRowColumnIds
				if(storeRackSideRowColumnIds != false) {
					this.listInventoryTemplateDetail = []
					this.getProductsForStoreRackSideIds(storeRackSideRowColumnIds)
					this.wizard = 2
				} else {
					alert('Se debe seleccionar al menos un modulo')
				}
			},
			actionBtnNext() {
				if(this.wizard == 1) {
					this.$refs.storesComponent.$refs.btnGetStoreRackSideRowColumnIdsSelected.click()
				} else if(this.wizard == 2) {
					this.clearObjectInventoryTemplate()
					this.wizard++
					this.objectInventoryTemplate.inventory_id = this.inventoryId
				}
			},
			getProductsForStoreRackSideResultLocal(response) {
				if(response.data.success == true) {
					this.listProductStoreRackSideRowColumns.forEach(element => {
						this.addFromProductStoreRackSideRowColumn(element)
					});
				}
			},
			resultAxiosLocal(responseLocal, response) {
				switch(responseLocal) {
					case 'getProductsForStoreRackSideResult': this.getProductsForStoreRackSideResult(response); break;
					case 'saveInventoryTemplateResult': this.saveInventoryTemplateResult(response); break;
					default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
				}
				this.$emit('hideLockScreen')
			},
			saveInventoryTemplateLocal() {
				this.listInventoryTemplateDetailFilter.forEach((e) => {
					this.clearObjectInventoryTemplateDetail()
					this.objectInventoryTemplate.inventory_template_detail.push({product_id: e.product_id, store_rack_side_row_column_id: e.store_rack_side_row_column_id, quantity: e.quantity})
				})
				this.objectInventoryTemplate.inventory_template_store_rack_side_row_column = this.storeRackSideRowColumnIds
				this.saveInventoryTemplate()
			},
			saveInventoryTemplateResultLocal(response) {
				if(response.data.success == true) {
					this.$emit('actionSaveInventoryTemplate', response.data.data)
				}
			},
			setComponentLocal() {
				this.wizard = 1
				this.$refs.storesComponent.$refs.btnGetStores.click()
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
